
	import { Vue,Component,Prop,Model,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import exicon from '../assets/expressicon'
    const partner = namespace('partner')
    @Component
    export default class Excom extends Vue{
        @partner.State('list') list:any
        @Model('change', { type: String }) value!: String
        partnerIcon:string = '' //快递员图标
        exicon:any = exicon
        val:any = ''
        @partner.Action('getPartnerList') getPartnerList:any
        @Prop({ type: Boolean | String, default: '' }) excooperation: Boolean
        async created(){
            this.getList();
        }
        async getList(){
            await this.getPartnerList({
                pageSize: 100,
                excooperation: this.excooperation,
            })
            this.val = this.value
            this.list.map((item:any)=>{
                if(item._id == this.value){
                    this.partnerIcon = item.excom.pinyin
                }
            })
        }
        change(e:any){
            this.$emit('change',e)
            if(e){
                this.list.map((item:any)=>{
                    if(item._id == e){
                        this.partnerIcon = item.excom.pinyin;
                        this.$emit('datachange', {
                            _id: item._id,
                            name: item.name,
                            pinyin: item.excom.pinyin,
                        });
                    }
                })
            }else{
                this.partnerIcon = ''
                this.$emit('datachange', {});
            }
        }
        @Watch('value')
        onChildChanged(val: string) {
            this.val = val
            if(val === '') {
                return this.partnerIcon = '';
            }
            this.list.map((item:any)=>{
                if(item._id == val){
                    this.partnerIcon = item.excom.pinyin
                }
            })
        }
        @Watch('excooperation')
        excooperationChange(){
            this.getList()
        }
    }
